import { legendStrokeColors } from 'utils/variables';

export const color = {
  colorLightTheme: legendStrokeColors.DARK,
  colorDarkTheme: legendStrokeColors.LIGHT
};

export const lineWidth = 1;

export const radius = 5;

export const circlePadding = 5;
export const textPadding = 6;
export const canvasPadding = 2;
export const rectPadding = 4;
